import {AllDeviceActivity, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import {
    getStatusByCalcKeyDeviceActivity
} from "@containers/device/containers/deviceActivity/helpers/getCalcKeyByKeyDeviceActivity";

export const getLabelStatusDeviceActivity = (status: StatusDeviceActivity):string=>{
    switch (status) {
        case "oneHour": {
            return 'base.oneHourLastOnline'
        }
        case "beforeLastMonth": {
            return 'base.beforeLastMonth'
        }
        case "inactive": {
            return 'base.inactive'
        }
        case "lastMonth": {
            return 'base.lastMonth'
        }
        case "lastDay": {
            return 'base.lastDay'
        }
        case "lastWeek": {
            return 'base.lastWeek'
        }
        case "notConnected": {
            return 'base.notConnected'
        }
        case "online": {
            return 'base.online'
        }
    }
}

export const getLabelTotalDeviceActivity = (key:keyof AllDeviceActivity):string=>{
    const status = getStatusByCalcKeyDeviceActivity(key)

    switch (status) {
        case "oneHour": {
            return 'base.oneHourLastOnline'
        }
        case "beforeLastMonth": {
            return 'base.beforeLastMonth'
        }
        case "inactive": {
            return 'base.inactive'
        }
        case "lastMonth": {
            return 'base.lastMonth'
        }
        case "lastDay": {
            return 'base.lastDay'
        }
        case "lastWeek": {
            return 'base.lastWeek'
        }
        case "notConnected": {
            return 'base.notConnected'
        }
        case "online": {
            return 'base.online'
        }
    }
}